export var DelegationOption;
(function (DelegationOption) {
    DelegationOption[DelegationOption["NotDelegated"] = 1] = "NotDelegated";
    DelegationOption[DelegationOption["DelegatedToMember"] = 2] = "DelegatedToMember";
    DelegationOption[DelegationOption["DelegatedToPartner"] = 3] = "DelegatedToPartner";
})(DelegationOption || (DelegationOption = {}));
